import React, { useEffect } from "react"
import { Twitter, Youtube } from "reactjs-social-embed"

import { graphql } from "gatsby"
import { ArticleEmbedFieldsFragment } from "../../../../../../graphql-types"

import * as styles from "./embed-social-media.module.scss"
import { elementOffset, transformItem } from "../../../functions/functions"

type EmbedSocialMediaProps = {
  data: ArticleEmbedFieldsFragment
}

const EmbedSocialMedia: React.FC<EmbedSocialMediaProps> = ({ data }) => {
  const displaySocialMediaEmbed = (): JSX.Element => {
    if (data.embedTwitter && data.twitterEmbedLink)
      return <Twitter id={data.twitterEmbedLink} parentClass={styles.twitter} />
    if (data.embedYoutube && data.youtubeEmbedLink)
      return <Youtube id={data.youtubeEmbedLink} parentClass={styles.youtube} />
    if (data.embedLinkedin && data.linkedinEmbedLink) {
      return (
        <iframe
          src={data.linkedinEmbedLink}
          className={styles.linkedin}
          title="LinkedIn link"
          height={data.linkedinEmbedHeight}
          scrolling="no"
        />
      )
    }
    return
  }

  const handleScrollAnimation = () => {
    document.addEventListener("scroll", () => {
      const container = document.getElementsByClassName(styles.container)

      Array.from(container).forEach(artContainer => {
        if (window.scrollY >= elementOffset(artContainer).top - 700) {
          transformItem(artContainer.getElementsByClassName(styles.content)[0], 400)
        }
      })
    })
  }

  useEffect(() => {
    handleScrollAnimation()
  }, [])

  return (
    <section className={styles.container}>
      <div className={styles.content}>
        {(data.embedTwitter || data.embedYoutube || data.embedLinkedin) && displaySocialMediaEmbed()}
      </div>
    </section>
  )
}

export const fragment = graphql`
  fragment ArticleEmbedFields on DatoCmsArticleEmbed {
    __typename
    id
    embedTwitter
    twitterEmbedLink
    embedYoutube
    youtubeEmbedLink
    embedLinkedin
    linkedinEmbedLink
    linkedinEmbedHeight
  }
`

export default EmbedSocialMedia
